<template>
  <div>
    <b-navbar toggleable="lg" fixed="top" class="bistro-weborders-header">
      <b-navbar-brand href="#" class="bo-navbar-title">
        Bistro
        <strong>Web Orders</strong>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- <b-navbar-nav> -->

        <!-- </b-navbar-nav> -->
        <!-- <b-navbar-nav class="mx-auto order-0">
          <b-navbar-brand href="#" class="mx-auto">

          </b-navbar-brand>
        </b-navbar-nav> -->

        <!-- Right aligned nav items -->
        <!-- <b-navbar-nav
          v-if="this.isMobile() && this.showFilter === true"
          class="ml-auto d-inline-block w-100 order-1"
        >
          <b-form-input
            size="sm"
            class="mr-sm-2 mr-xl-4"
            placeholder="¿Qué querés comer hoy?"
            @change="onInputChanged"
          ></b-form-input>
        </b-navbar-nav>
        <b-navbar-nav v-else-if="this.showFilter === true" class="ml-auto d-inline-block order-1">
          <b-form-input
            size="sm"
            class="mr-sm-2 mr-xl-4"
            placeholder="¿Qué querés comer hoy?"
            @change="onInputChanged"
          ></b-form-input>
        </b-navbar-nav> -->
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import mobile_detection from "../mixins/mobile_detection";

export default {
  mixins: [mobile_detection],
  props: {
			showFilter: {
				type: Boolean,
				default: true
			}
		},
  head() {
    return {
      title: "Bistro WebOrders"
    };
  },
  methods: {
    onInputChanged(text) {
      this.$emit('onFilterChanged', text);
    }
  },
  data() {
    return {
      filter: ''
    };
  }
};
</script>
<style scoped>
.bwo-search-bar {
  max-width: 400px;
  width: 100% !important;
}
</style>
<style scoped>
.bistro-weborders-header {
  background-color: #f0f0f0;
}
.bo-navbar-title {
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/Components/Header.vue